import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import {
  Typography,
  TextField,
  Button,
  Modal,
  Drawer,
  Divider,
  Checkbox,
  TableSortLabel,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import Swal from "sweetalert2";
import ClearIcon from "@mui/icons-material/Clear";
import { dataProductList, groundingProduct } from "../Service";
import moment from "moment";
import LoadingButton from "@mui/lab/LoadingButton";
import CloseIcon from "@mui/icons-material/Close";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { addLog } from "../../utils/addLog";
import CircularProgress from "@mui/material/CircularProgress";
import { useTranslation } from "react-i18next";
import { dataAccessPermission } from "../../utils/dataAccessPermission";
import GroundingList from "./GroundingList";
import { signOut } from "../../utils/signOut";

const styleGrayBtn = {
  backgroundColor: "#5C5C5C",
  color: "#FFFFFF",
  borderRadius: "10px",
  height: "45px",
  textTransform: "none",
  width: "100px",
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 450,
  bgcolor: "background.paper",
  borderRadius: 3,
  boxShadow: 24,
  p: 4,
};

const styleModaldelete = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  height: 200,
  bgcolor: "background.paper",
  borderRadius: 3,
  boxShadow: 24,
  p: 3,
};

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box
      sx={{
        flexShrink: 0,
        ml: 2.5,
      }}
    >
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function Product() {
  const [t, i18n] = useTranslation("global");

  const [userData, setUserData] = React.useState(
    JSON.parse(sessionStorage.getItem("authUserData"))
  );

  const [selected, setSelected] = useState([]);

  const [dataProduct, setDataProduct] = useState([]);

  const styles = {
    BtnIcon: {
      width: 32,
      height: 32,
    },
  };
  //
  const [anchorElAction, setAnchorElAction] = React.useState(null);
  const handleOpenActionMenu = (event) => {
    setAnchorElAction(event.currentTarget);
  };
  const handleCloseActionMenu = () => {
    setAnchorElAction(null);
  };
  // Selected row
  const [anchorElActionSelected, setAnchorElActionSelected] =
    React.useState(null);
  const handleOpenActionMenuSelected = (event) => {
    setAnchorElActionSelected(event.currentTarget);
  };
  const handleCloseActionMenuSelected = () => {
    setAnchorElActionSelected(null);
  };

  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedProdSplitLine, setSelectedProdSplitLine] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const handleRowClick = (IDItem) => {
    const product = dataProduct
      .filter((row) => row.IDItem === IDItem)
      .map((row) => row);
    const splitLine = product[0].ItemDescription.split("\n");

    setSelectedProduct(product[0]);
    setSelectedProdSplitLine(splitLine);
    setDrawerOpen(true);
  };
  const handleCloseDrawer = () => {
    setDrawerOpen(false);
    setSelectedProduct(null);
    setSelectedProdSplitLine(null);
  };

  const fileRef = useRef(null);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchInput, setSearchInput] = useState("");

  const [errorMsg, setErrorMsg] = useState("");
  const [sumErrorMsg, setSumErrorMsg] = useState("");

  const [loading, setLoading] = useState(false);

  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    handleCloseActionMenu();
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setErrorMsg("");
  };

  const [isAll, setIsAll] = useState(true);
  // Grounding List modal
  const [openModalGroundingList, setOpenModalGroundingList] = useState(false);
  const handleOpenModalGroundingList = () => {
    setOpenModalGroundingList(true);
  };
  const handleCloseModalGroundingList = () => {
    setOpenModalGroundingList(false);
    setSelected([]);
    // Reload page after update price
    setPage(0);
    getData(0, rowsPerPage);
  };

  const handleClearSearchProduct = () => {
    setSearchInput("");
    setSelected([]); // Clear selected row
  };

  const [openModalGrounding, setOpenModalGrounding] = useState(false);
  const [loadingBtnGrounding, setLoadingBtnGrounding] = useState(false);
  const handleOpenModalGrounding = () => {
    setOpenModalGrounding(true);
  };
  const handleCloseModalGrounding = () => setOpenModalGrounding(false);

  const handleClickModalGrounding = () => {
    // Phase 2
    setLoadingBtnGrounding(true);
    groundingSearch();
    addLog("Product", "Grounding search", null);
  };

  const groundingSearch = async () => {
    const role = dataAccessPermission("OWNER");

    var dataForm = {
      ID: selected,
      UserRole: role,
    };

    await groundingProduct(dataForm).then((res) => {
      if (res && res.status === 200 && res.data.success === true) {
        handleCloseModalGrounding();
        setIsAll(false);
        handleOpenModalGroundingList();
      } else if (res.status === 401) {
        handleCloseModalGrounding();
        signOut();
      } else {
        handleCloseModalGrounding();
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.message,
        });
        console.log(`error groundingProduct:`, res.data.message);
      }
      setLoadingBtnGrounding(false);
    });
  };

  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("GroupID");

  const handleSelect = (id) => {
    const newSelected = selected.includes(id)
      ? selected.filter((item) => item !== id)
      : [...selected, id];
    setSelected(newSelected);
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedData = [...dataProduct].sort((a, b) => {
    if (order === "asc") {
      return a[orderBy] < b[orderBy] ? -1 : 1;
    } else {
      return a[orderBy] > b[orderBy] ? -1 : 1;
    }
  });

  const headCells = [
    {
      id: "code",
      numeric: false,
      disablePadding: true,
      sortKey: "IDItem",
      label: t("grounding.table.header.code"),
    },
    {
      id: "product",
      numeric: false,
      disablePadding: true,
      sortKey: "itemname",
      label: t("grounding.table.header.product"),
    },
    {
      id: "uom",
      numeric: false,
      disablePadding: false,
      sortKey: "UoMItem",
      label: t("grounding.table.header.uom"),
    },
    {
      id: "model",
      numeric: false,
      disablePadding: false,
      sortKey: "model",
      label: t("grounding.table.header.model"),
    },
    {
      id: "description",
      numeric: false,
      disablePadding: false,
      sortKey: "ItemDescription",
      label: t("grounding.table.header.description"),
    },
    {
      id: "MatLaborCost",
      numeric: true,
      disablePadding: false,
      sortKey: "MaterialLaborCost",
      label: t("grounding.table.header.labor_price"),
    },
    {
      id: "uprice",
      numeric: true,
      disablePadding: false,
      sortKey: "material_Price",
      label: t("grounding.table.header.price"),
    },
    {
      id: "PriceHomepro",
      numeric: true,
      disablePadding: false,
      sortKey: "matPriceHome",
      label: t("grounding.table.header.priceHome"),
    },
    {
      id: "PriceThaiWat",
      numeric: true,
      disablePadding: false,
      sortKey: "matPriceThai",
      label: t("grounding.table.header.priceThai"),
    },
    {
      id: "PriceBoon",
      numeric: true,
      disablePadding: false,
      sortKey: "matPriceBoon",
      label: t("grounding.table.header.priceBoon"),
    },
    {
      id: "Other",
      numeric: true,
      disablePadding: false,
      sortKey: "matPriceOth",
      label: t("grounding.table.header.priceOth"),
    },
    {
      id: "Reference",
      numeric: false,
      disablePadding: false,
      sortKey: null,
      label: t("grounding.table.header.ref"),
    },
    {
      id: "SearchedOn",
      numeric: false,
      disablePadding: false,
      sortKey: "last_updated",
      label: t("grounding.table.header.last"),
    },
  ];

  // Snack Bar
  const vertical = "top";
  const horizontal = "right";
  const [openSnack, setOpenSnack] = useState(false);

  const handleClickSnack = () => {
    setOpenSnack(true);
  };

  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnack(false);
  };

  const [data, setData] = useState({ total: 0 });

  React.useEffect(() => {
    getData(0, rowsPerPage);
  }, []);

  const getData = async (nowPage, nowRowsPerPage) => {
    setSelected([]); // Clear selected row

    setLoading(true);

    const role = dataAccessPermission("OPTION");

    var nowPages = nowPage + 1;

    let qString = `?page=${nowPages}&perpage=${nowRowsPerPage}`;
    qString += `&UserRole=${role}`;
    if (searchInput) qString = qString + "&KeyWord=" + searchInput;

    await dataProductList(qString).then((res) => {
      if (res && res?.status === 200) {
        // For paginate
        setDataProduct(res.data.data);
        setData(res.data);
      } else if (res?.status === 401) {
        signOut();
      } else if (res === undefined) {
        Swal.fire({
          icon: "error",
          title: "Database connection failed",
          text: "Please contact administrator",
        });
      }
      setLoading(false);
    });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getData(newPage, rowsPerPage);
  };

  const handleChangeRowsPerPage = (event) => {
    // If value is -1, request ALL rows (no pagination)
    if (event.target.value === -1) {
      setRowsPerPage(-1);
      getData(0, data.total);
      setPage(0);
      return;
    }

    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    getData(0, event.target.value);
  };

  const handleClickSearch = async () => {
    setPage(0);
    await getData(0, rowsPerPage);
    addLog("Product", "Search", null);
  };

  let NumberForm = new Intl.NumberFormat("th-TH", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });

  function CodeForm(id) {
    return String(id).padStart(5, "0"); // Pads the number to be 5 characters long
  }

  // Copy to clipboard
  const handleCopyClick = (textToCopy) => {
    navigator.clipboard.writeText(textToCopy).then(() => {
      setOpenSnack(true);
    });
  };

  return (
    <Box
      sx={{
        margin: "65px 0px 0px 0px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Snackbar
        open={openSnack}
        autoHideDuration={2000}
        onClose={handleCloseSnack}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        message={t("common.message.copy")}
      />

      {/*  ////////////////////////// Search Box ////////////////////////// */}
      <Box
        sx={{
          display: "flex",
          paddingBottom: "20px",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Box
            sx={{ width: { lg: "700px", md: "500px" }, display: "flex", mr: 2 }}
          >
            <TextField
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderColor: "white",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "white",
                },
              }}
              placeholder={t("grounding.txtbox.search")}
              size="middle"
              variant="outlined"
              InputProps={{
                style: {
                  borderRadius: "10px",
                  backgroundColor: "#F0F0F0",
                  paddingLeft: "15px",
                  fontSize: "medium",
                },
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
                endAdornment: (
                  <IconButton
                    sx={{
                      visibility: searchInput ? "visible" : "hidden",
                    }}
                    onClick={handleClearSearchProduct}
                  >
                    <ClearIcon />
                  </IconButton>
                ),
              }}
              fullWidth
              value={searchInput}
              onChange={(e) => {
                setSearchInput(e.target.value);
              }}
            />
          </Box>

          <Box>
            <Button
              onClick={handleClickSearch}
              variant="contained"
              size="small"
              sx={styleGrayBtn}
            >
              {t("common.button.search")}
            </Button>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          {selected.length > 0 ? (
            <>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <Box sx={{ mr: 2 }}>
                  <Typography>
                    {t("grounding.text.sel")}
                    {selected.length}
                    {t("grounding.text.unit")}
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", mr: 2 }}>
                  <Button
                    onClick={handleOpenModalGrounding}
                    variant="contained"
                    size="medium"
                    startIcon={<SearchIcon />}
                    style={{
                      textTransform: "none",
                      borderRadius: "10px",
                      height: "45px",
                    }}
                  >
                    Grounding search
                  </Button>
                </Box>
              </Box>
            </>
          ) : (
            ""
          )}

          <Box sx={{ mr: 2 }}>
            <Button
              onClick={() => {
                setIsAll(true);
                handleOpenModalGroundingList();
              }}
              variant="contained"
              size="small"
              style={{
                width: "auto",
              }}
              sx={styleGrayBtn}
            >
              {t("grounding.button.waitconf")}
            </Button>
          </Box>
        </Box>
      </Box>

      {/*  ////////////////////////// Data Table ////////////////////////// */}
      <TableContainer sx={{ maxHeight: 680 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell
                padding="checkbox"
                sx={{
                  backgroundColor: "#c4e6ff",
                }}
              >
                <Checkbox
                  checked={
                    selected.length === dataProduct.length &&
                    dataProduct.length !== 0
                  }
                  onChange={() =>
                    setSelected(
                      selected.length === dataProduct.length
                        ? []
                        : dataProduct.map((item) => item.IDItem)
                    )
                  }
                />
              </TableCell>

              {headCells.map((headCell, index) => (
                <TableCell
                  key={index}
                  align={headCell.numeric ? "right" : "left"}
                  padding={headCell.disablePadding ? "none" : "normal"}
                  sx={{
                    backgroundColor: "#c4e6ff",
                    padding: "10px",
                    fontWeight: "bold",
                    color: "#1D589D",
                  }}
                  sortDirection={orderBy === headCell.sortKey ? order : false}
                >
                  {headCell.sortKey !== null ? (
                    <TableSortLabel
                      active={orderBy === headCell.sortKey}
                      direction={orderBy === headCell.sortKey ? order : "asc"}
                      onClick={() => handleRequestSort(headCell.sortKey)}
                    >
                      {headCell.label}
                    </TableSortLabel>
                  ) : (
                    headCell.label
                  )}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={13}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <CircularProgress color="inherit" />
                  </Box>
                </TableCell>
              </TableRow>
            ) : sortedData.length > 0 ? (
              sortedData.map((row, index) => (
                <React.Fragment key={index}>
                  <TableRow>
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={selected.includes(row.IDItem)}
                        onChange={() => handleSelect(row.IDItem)}
                      />
                    </TableCell>
                    <TableCell style={{ width: 50 }} align="left">
                      <Typography>{CodeForm(row.IDItem)}</Typography>
                    </TableCell>
                    <TableCell style={{ minWidth: "250px" }} align="left">
                      <Button
                        variant="text"
                        style={{
                          textTransform: "none",
                          fontSize: "16px",
                          textAlign: "left",
                          display: "flex",
                          justifyContent: "flex-start",
                          color: "black",
                        }}
                        size="small"
                        onClick={() => handleRowClick(row.IDItem)}
                      >
                        <Typography
                          sx={{
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            WebkitLineClamp: 2, // Limits to 2 lines
                            textOverflow: "ellipsis",
                          }}
                        >
                          {row.itemname}
                        </Typography>
                      </Button>
                    </TableCell>
                    <TableCell style={{ width: 150 }} align="left">
                      <Typography>{row.UoMItem}</Typography>
                    </TableCell>
                    <TableCell
                      style={{
                        minWidth: "50px",
                        maxWidth: "120px",
                      }}
                      align="left"
                    >
                      <Typography
                        sx={{
                          display: "-webkit-box",
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          WebkitLineClamp: 2, // Limits to 2 lines
                          textOverflow: "ellipsis",
                        }}
                      >
                        {row.model}
                      </Typography>
                    </TableCell>
                    <TableCell style={{ minWidth: "250px" }} align="left">
                      <Typography
                        sx={{
                          display: "-webkit-box",
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          WebkitLineClamp: 2, // Limits to 2 lines
                          textOverflow: "ellipsis",
                        }}
                      >
                        {row.ItemDescription}
                      </Typography>
                    </TableCell>
                    <TableCell style={{ width: 150 }} align="right">
                      <Typography>
                        {NumberForm.format(row.MaterialLaborCost)}
                      </Typography>
                    </TableCell>
                    <TableCell style={{ width: 150 }} align="right">
                      <Typography>
                        {NumberForm.format(row.material_Price)}
                      </Typography>
                    </TableCell>
                    <TableCell style={{ width: 150 }} align="right">
                      <Typography>
                        {NumberForm.format(row.matPriceHome)}
                      </Typography>
                    </TableCell>
                    <TableCell style={{ width: 150 }} align="right">
                      <Typography>
                        {NumberForm.format(row.matPriceThai)}
                      </Typography>
                    </TableCell>
                    <TableCell style={{ width: 150 }} align="right">
                      <Typography>
                        {NumberForm.format(row.matPriceBoon)}
                      </Typography>
                    </TableCell>
                    <TableCell style={{ width: 150 }} align="right">
                      <Typography>
                        {NumberForm.format(row.matPriceOth)}
                      </Typography>
                    </TableCell>

                    <TableCell style={{ minWidth: 80 }} align="left">
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        {row.urlHome ? (
                          <Button
                            variant="text"
                            style={{
                              textTransform: "none",
                              textAlign: "left",
                              display: "flex",
                              justifyContent: "flex-start",
                              padding: 0,
                            }}
                            size="small"
                          >
                            <Typography
                              style={{
                                whiteSpace: "normal",
                                wordBreak: "break-word",
                              }}
                              sx={{
                                display: "-webkit-box",
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                                WebkitLineClamp: 1, // Limits to 1 lines
                                textOverflow: "ellipsis",
                                fontSize: "12px",
                              }}
                            >
                              <a
                                href={row.urlHome}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  color: "inherit",
                                }}
                              >
                                HomePro
                              </a>
                            </Typography>
                          </Button>
                        ) : (
                          ""
                        )}

                        {row.urlThai ? (
                          <Button
                            variant="text"
                            style={{
                              textTransform: "none",
                              textAlign: "left",
                              display: "flex",
                              justifyContent: "flex-start",
                              padding: 0,
                            }}
                            size="small"
                          >
                            <Typography
                              style={{
                                whiteSpace: "normal",
                                wordBreak: "break-word",
                              }}
                              sx={{
                                display: "-webkit-box",
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                                WebkitLineClamp: 1, // Limits to 1 lines
                                textOverflow: "ellipsis",
                                fontSize: "12px",
                              }}
                            >
                              <a
                                href={row.urlThai}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  color: "inherit",
                                }}
                              >
                                Thai watsadu
                              </a>
                            </Typography>
                          </Button>
                        ) : (
                          ""
                        )}

                        {row.urlBoon ? (
                          <Button
                            variant="text"
                            style={{
                              textTransform: "none",
                              textAlign: "left",
                              display: "flex",
                              justifyContent: "flex-start",
                              padding: 0,
                            }}
                            size="small"
                          >
                            <Typography
                              style={{
                                whiteSpace: "normal",
                                wordBreak: "break-word",
                              }}
                              sx={{
                                display: "-webkit-box",
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                                WebkitLineClamp: 1, // Limits to 1 lines
                                textOverflow: "ellipsis",
                                fontSize: "12px",
                              }}
                            >
                              <a
                                href={row.urlBoon}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  color: "inherit",
                                }}
                              >
                                Boonthavorn
                              </a>
                            </Typography>
                          </Button>
                        ) : (
                          ""
                        )}
                        {row.urlOth ? (
                          row.urlOth.startsWith("https://") ? (
                            <Button
                              variant="text"
                              style={{
                                textTransform: "none",
                                textAlign: "left",
                                display: "flex",
                                justifyContent: "flex-start",
                                padding: 0,
                              }}
                              size="small"
                            >
                              <Typography
                                style={{
                                  whiteSpace: "normal",
                                  wordBreak: "break-word",
                                }}
                                sx={{
                                  display: "-webkit-box",
                                  WebkitBoxOrient: "vertical",
                                  overflow: "hidden",
                                  WebkitLineClamp: 1, // Limits to 1 lines
                                  textOverflow: "ellipsis",
                                  fontSize: "12px",
                                }}
                              >
                                <a
                                  href={row.urlOth}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    textDecoration: "none",
                                    color: "inherit",
                                  }}
                                >
                                  Other
                                </a>
                              </Typography>
                            </Button>
                          ) : (
                            <div>
                              <Button
                                variant="text"
                                style={{
                                  textTransform: "none",
                                  textAlign: "left",
                                  display: "flex",
                                  justifyContent: "flex-start",
                                  padding: 0,
                                }}
                                size="small"
                                onClick={() => {
                                  handleCopyClick(row.urlOth);
                                }}
                              >
                                <Typography
                                  style={{
                                    whiteSpace: "normal",
                                    wordBreak: "break-word",
                                  }}
                                  sx={{
                                    display: "-webkit-box",
                                    WebkitBoxOrient: "vertical",
                                    overflow: "hidden",
                                    WebkitLineClamp: 1, // Limits to 1 lines
                                    textOverflow: "ellipsis",
                                    fontSize: "12px",
                                  }}
                                >
                                  Other
                                </Typography>
                              </Button>
                            </div>
                          )
                        ) : (
                          ""
                        )}
                        {row.urlOth2 ? (
                          row.urlOth2.startsWith("https://") ? (
                            <Button
                              variant="text"
                              style={{
                                textTransform: "none",
                                textAlign: "left",
                                display: "flex",
                                justifyContent: "flex-start",
                                padding: 0,
                              }}
                              size="small"
                            >
                              <Typography
                                style={{
                                  whiteSpace: "normal",
                                  wordBreak: "break-word",
                                }}
                                sx={{
                                  display: "-webkit-box",
                                  WebkitBoxOrient: "vertical",
                                  overflow: "hidden",
                                  WebkitLineClamp: 1, // Limits to 1 lines
                                  textOverflow: "ellipsis",
                                  fontSize: "12px",
                                }}
                              >
                                <a
                                  href={row.urlOth2}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    textDecoration: "none",
                                    color: "inherit",
                                  }}
                                >
                                  Other2
                                </a>
                              </Typography>
                            </Button>
                          ) : (
                            <div>
                              <Button
                                variant="text"
                                style={{
                                  textTransform: "none",
                                  textAlign: "left",
                                  display: "flex",
                                  justifyContent: "flex-start",
                                  padding: 0,
                                }}
                                size="small"
                                onClick={() => {
                                  handleCopyClick(row.urlOth2);
                                }}
                              >
                                <Typography
                                  style={{
                                    whiteSpace: "normal",
                                    wordBreak: "break-word",
                                  }}
                                  sx={{
                                    display: "-webkit-box",
                                    WebkitBoxOrient: "vertical",
                                    overflow: "hidden",
                                    WebkitLineClamp: 1, // Limits to 1 lines
                                    textOverflow: "ellipsis",
                                    fontSize: "12px",
                                  }}
                                >
                                  Other2
                                </Typography>
                              </Button>
                            </div>
                          )
                        ) : (
                          ""
                        )}
                      </Box>
                    </TableCell>

                    <TableCell
                      style={{
                        minWidth: "100px",
                        maxWidth: "120px",
                      }}
                      align="left"
                    >
                      <Typography variant="body2">
                        {row.last_updated
                          ? moment(row.last_updated).format(
                              "YYYY-MM-DD HH:mm:ss"
                            )
                          : ""}
                      </Typography>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={13}>
                  <Box
                    style={{ display: "flex", justifyContent: "center" }}
                  ></Box>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
          {/* Original */}
          {/* <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[
                  10,
                  25,
                  50,
                  100,
                  { label: "All", value: -1 },
                ]}
                colSpan={14}
                count={data.total}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </TableRow>
          </TableFooter> */}
        </Table>
      </TableContainer>
      <TableFooter
        align="right"
        sx={
          {
            // borderTop: "1px solid lightgray",
          }
        }
      >
        <TableRow>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50, 100, { label: "All", value: -1 }]}
            // colSpan={14}
            count={data.total}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            ActionsComponent={TablePaginationActions}
          />
        </TableRow>
      </TableFooter>

      {/* /////////// Modal confirm grounding search /////////// */}
      <Modal open={openModalGrounding}>
        <Box sx={styleModaldelete}>
          <Box style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography marginTop={1} variant="h5" component="h2">
              {t("grounding.popup.groundsearch.header")}
            </Typography>
            <IconButton size="large" onClick={handleCloseModalGrounding}>
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </Box>
          <Typography
            sx={{ mt: 3, color: "#616161" }}
            fontSize={14}
            fontWeight={300}
          >
            {t("grounding.popup.groundsearch.txt1")}
          </Typography>
          <Box
            style={{
              display: "flex",
              justifyContent: "end",
              marginTop: "5rem",
            }}
          >
            <LoadingButton
              onClick={handleClickModalGrounding}
              loading={loadingBtnGrounding}
              loadingPosition="start"
              startIcon={<SearchIcon />}
              variant="contained"
              size="medium"
            >
              {t("grounding.button.grounding")}
            </LoadingButton>
            <Button
              style={{ marginLeft: 12 }}
              variant="outlined"
              size="medium"
              onClick={handleCloseModalGrounding}
            >
              {t("common.button.cancel")}
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Drawer Product detail */}
      <Drawer anchor="right" open={drawerOpen} onClose={handleCloseDrawer}>
        <Box sx={{ width: 400, padding: 4 }} role="presentation">
          {selectedProduct && (
            <>
              <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
                {/* <Typography variant="h6">Product/&nbsp;</Typography> */}
                <Typography variant="h6">
                  {t("grounding.table.header.product")}/&nbsp;
                </Typography>
                <Typography variant="h6" color="primary">
                  {selectedProduct.itemname}
                </Typography>
              </Box>
              <Box
                sx={{
                  marginTop: 2,
                  display: "flex",
                  flexDirection: "column",
                  width: "60%",
                }}
              >
                <Box sx={{ marginBottom: 2 }}>
                  {/* <Typography variant="subtitle2">Product code</Typography> */}
                  <Typography variant="subtitle2">
                    {t("grounding.text.code")}
                  </Typography>
                  <Typography>{selectedProduct.IDItem}</Typography>
                  <Divider />
                </Box>
                <Box sx={{ marginBottom: 2 }}>
                  {/* <Typography variant="subtitle2">Product name</Typography> */}
                  <Typography variant="subtitle2">
                    {t("grounding.text.product")}
                  </Typography>
                  <Typography>{selectedProduct.itemname}</Typography>
                  <Divider />
                </Box>
                <Box sx={{ marginBottom: 2 }}>
                  {/* <Typography variant="subtitle2">Model or Type</Typography> */}
                  <Typography variant="subtitle2">
                    {t("grounding.text.model")}
                  </Typography>
                  <Typography>{selectedProduct.model}</Typography>
                  <Divider />
                </Box>
                <Box sx={{ marginBottom: 2 }}>
                  {/* <Typography variant="subtitle2">Price</Typography> */}
                  <Typography variant="subtitle2">
                    {t("grounding.text.price")}
                  </Typography>
                  <Box
                    sx={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Typography>
                      {NumberForm.format(selectedProduct.material_Price)}
                    </Typography>
                    <Typography>฿</Typography>
                  </Box>
                  <Divider />
                </Box>
                <Box sx={{ marginBottom: 2 }}>
                  {/* <Typography variant="subtitle2">Company</Typography> */}
                  <Typography variant="subtitle2">
                    {t("grounding.text.company")}
                  </Typography>
                  <Typography>
                    {selectedProduct.company ? selectedProduct.company : "N/A"}
                  </Typography>
                  <Divider />
                </Box>
              </Box>
              <Box>
                <Box sx={{ marginBottom: 2 }}>
                  {/* <Typography variant="subtitle2">Reference</Typography> */}
                  <Typography variant="subtitle2">
                    {t("grounding.text.ref")}
                  </Typography>
                  <Box sx={{ width: "100%" }}>
                    <Typography
                      style={{ whiteSpace: "normal", wordBreak: "break-word" }}
                    >
                      {selectedProduct.URI ? selectedProduct.URI : "N/A"}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ marginBottom: 2, marginTop: 2 }}>
                  {/* <Typography variant="subtitle2">Description</Typography> */}
                  <Typography variant="subtitle2">
                    {t("grounding.text.description")}
                  </Typography>
                  <Box>
                    {selectedProdSplitLine.map((detail, index) => (
                      <Typography
                        key={index}
                        variant="body1"
                        component="div"
                        sx={{ display: "flex", alignItems: "center" }}
                      >
                        <span style={{ marginRight: "8px", fontSize: "20px" }}>
                          •
                        </span>
                        {detail}
                      </Typography>
                    ))}
                  </Box>
                </Box>
              </Box>
            </>
          )}
        </Box>
      </Drawer>

      {/* /////////// Modal Grounding List /////////// */}
      <Dialog open={openModalGroundingList} fullWidth maxWidth="lg">
        <Box style={{ display: "flex", justifyContent: "space-between" }}>
          <DialogTitle>
            {t("grounding.modal.gdsearchconfirm.title")}
          </DialogTitle>
          <IconButton size="large" onClick={handleCloseModalGroundingList}>
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </Box>
        <DialogContent>
          <GroundingList
            selectedGround={selected}
            emptyList={handleCloseModalGroundingList}
            listAll={isAll}
          />
        </DialogContent>
      </Dialog>
    </Box>
  );
}
